import { ArrowBack } from "@material-ui/icons";
import React from "react";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { Link } from "react-router-dom";
export const SubDropDown = ({ onClick, children, class_name }) => {
  return (
    <ul className={class_name}>
      <li>
        <Link to="#" class="link" onClick={onClick && onClick}>
          <span class="back-arrow icon">
            <ArrowBack />
          </span>
          Go back
        </Link>
      </li>
      {children ? (
        children
      ) : (
        <li className="my-2 hover-bg-none flex ai-c">
          <span class="back-arrow icon red">
            <ErrorOutlineIcon />
          </span>
          No Content available
        </li>
      )}
    </ul>
  );
};
